import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Logo, AmIcon, ArrowDownIcon } from "@/components/Icons";
import { Link } from "react-router-dom";
import { URL_ROOT } from "@/constants/urls";

export default function Navbar() {
  return (
    <Box as="header" bg="primary.800" w="full">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        maxW="8xl"
        mx="auto"
        px={{ base: 6, md: 0 }}
        py={4}
      >
        <Flex as={Link} to={URL_ROOT} alignItems="center" gap={4}>
          <Logo w="60px" h="56px" color="white" />
          <Flex borderLeftWidth="1px" borderLeftColor="white" h="56px" alignItems="center" pl={4}>
            <Text color="white" textStyle="body.bold">
              Իմ Տվյալները
            </Text>
          </Flex>
        </Flex>

        {/* <Flex alignItems="center" gap={2}>
          <Box w={6} h={6}>
            <AmIcon w={6} h={6} />
          </Box>
          <Text color="white" textStyle="body.regular">
            Հայերեն
          </Text>
          <ArrowDownIcon w="10px" h="5px" color="white" />
        </Flex> TODO::: add language selector */}
      </Flex>
    </Box>
  );
}
